import Dialog from "../dialog/Dialog";

const UnsavedSectionDialog = ({
  open,
  sectionLabel,
  onStay,
  onSaveAndContinue,
  onDiscardLeave,
  onDiscardNavigation,
  isSaving = false,
  showSaveButton = true,
  leaveMode = false,
}) => {
  const onDiscard = leaveMode ? onDiscardLeave : onDiscardNavigation;

  const helperText = !showSaveButton
    ? "Save this section before moving to another one."
    : leaveMode
      ? "Save them to your draft, or leave and lose these edits."
      : "Save them to your draft, or continue and lose these edits.";

  return (
    <Dialog
      open={open}
      onClose={onStay}
      title="Unsaved changes"
      maxWidth="md"
      fitContent
      showCloseButton={false}
      showHeaderCloseButton
      closeButtonAction={onStay}
      primaryButtonText={showSaveButton ? "Save draft" : null}
      primaryButtonAction={showSaveButton ? onSaveAndContinue : null}
      isLoading={isSaving}
      footerSecondaryContent={
        onDiscard ? (
          <button
            type="button"
            onClick={onDiscard}
            disabled={isSaving}
            className="inline-flex min-h-[38px] w-full items-center justify-center whitespace-nowrap rounded-md bg-white px-3 py-2 text-sm font-semibold text-red-600 shadow-sm ring-1 ring-inset ring-red-200 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
          >
            Exit without saving
          </button>
        ) : null
      }
    >
      <div className="flex items-start gap-3 pb-1">
        <span
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-50 text-amber-600"
          aria-hidden="true"
        >
          <i className="fi fi-rr-triangle-warning text-base leading-none" />
        </span>
        <div className="min-w-0 space-y-1">
          <p className="text-sm text-gray-700">
            You have unsaved changes in{" "}
            <span className="font-semibold text-gray-900">{sectionLabel}</span>.
          </p>
          <p className="text-sm text-gray-500">{helperText}</p>
        </div>
      </div>
    </Dialog>
  );
};

export default UnsavedSectionDialog;
